import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { TranscricaoAnexo } from '../../transcricaoTypes';
import { formatTamanhoArquivo, getExtensaoArquivo, MOBILE_BREAKPOINT } from '../../transcricaoAnexoUtils';
import TranscricaoAnexosCardList from './TranscricaoAnexosCardList';
import {
  sxAnexosExcluirButton,
  sxAnexosTableCell,
  sxAnexosTableContainer,
  sxAnexosTableHeaderCell,
  sxAnexosTableRow,
} from './sxTranscricaoAnexos';

interface TranscricaoAnexosTableProps {
  anexos: TranscricaoAnexo[];
  onExcluir: (index: number) => void;
}

const COLUNAS = ['Documentos', 'Tipo', 'Tamanhos', 'Excluir'] as const;

const TranscricaoAnexosTable: React.FC<TranscricaoAnexosTableProps> = ({ anexos, onExcluir }) => {
  const accessibility = useAccessibility();
  const isMobileLayout = useMediaQuery(MOBILE_BREAKPOINT);

  if (isMobileLayout) {
    return <TranscricaoAnexosCardList anexos={anexos} onExcluir={onExcluir} />;
  }

  return (
    <TableContainer
      style={accessibility.contrastBorderAccessibility}
      className="container-table-result-exam transcricao-anexos-table"
      sx={sxAnexosTableContainer}
      component={Paper}
    >
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            {COLUNAS.map((coluna) => (
              <TableCell
                key={coluna}
                component="th"
                scope="col"
                align="left"
                style={accessibility.textStyleAccessibility}
                sx={sxAnexosTableHeaderCell}
              >
                <b>{coluna}</b>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {anexos.map((anexo, index) => (
            <TableRow
              key={`${anexo.nomeArquivo}-${index}`}
              sx={sxAnexosTableRow}
            >
              <TableCell style={accessibility.textStyleAccessibility} sx={sxAnexosTableCell}>
                {anexo.nomeArquivo}
              </TableCell>
              <TableCell style={accessibility.textStyleAccessibility} sx={sxAnexosTableCell}>
                {getExtensaoArquivo(anexo.nomeArquivo)}
              </TableCell>
              <TableCell style={accessibility.textStyleAccessibility} sx={sxAnexosTableCell}>
                {formatTamanhoArquivo(anexo.tamanhoBytes)}
              </TableCell>
              <TableCell sx={sxAnexosTableCell}>
                <IconButton
                  onClick={() => onExcluir(index)}
                  sx={sxAnexosExcluirButton}
                  aria-label={`Excluir arquivo ${anexo.nomeArquivo}`}
                  size="small"
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TranscricaoAnexosTable;
